import type { RedisMigrationStatus } from './migrations';

function isRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

/** Проверяем HTTP-ответ: TypeScript-тип RTK Query не проверяет JSON во время выполнения. */
export function isRedisMigrationStatus(
  value: unknown
): value is RedisMigrationStatus {
  if (!isRecord(value)) return false;
  if (
    typeof value.migrationId !== 'string' ||
    typeof value.status !== 'string' ||
    typeof value.stage !== 'string' ||
    !['running', 'completed', 'failed', 'stopped', 'interrupted'].includes(
      value.status
    ) ||
    !['export', 'import', 'archive', 'finished'].includes(value.stage)
  )
    return false;
  return ['export', 'import', 'archive'].every((name) => {
    const step = value[name];
    return (
      isRecord(step) &&
      typeof step.status === 'string' &&
      [
        'pending',
        'running',
        'completed',
        'failed',
        'skipped',
        'stopped'
      ].includes(step.status) &&
      (step.progress === undefined || isRecord(step.progress))
    );
  });
}

export function normalizeRedisMigrationStatus(
  value: unknown
): RedisMigrationStatus | null {
  // Nest возвращает пустое тело для null. Legacy HTTP-клиент оборачивает его
  // в { data: '' }; символ с метаданными Axios не влияет на Object.keys.
  if (value == null || value === '') return null;
  if (isRecord(value) && Object.keys(value).length === 1 && value.data === '')
    return null;
  if (!isRedisMigrationStatus(value))
    throw new Error('Invalid Redis migration status response');
  return value;
}
